import { Link } from "react-router-dom";
import storycraftLogo from "@/assets/storycraft-logo-new.png";
import { Lock } from "lucide-react";

export const FooterSection = () => {
  return (
    <footer style={{ background: '#FFFFFF', borderTop: '1px solid #E5E7EB' }} className="py-10 md:py-12">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center gap-6">
          <Link to="/" className="flex items-center gap-3">
            <img src={storycraftLogo} alt="AI StoryCraft Studio" className="w-8 h-8 rounded-lg object-contain" />
            <span className="font-display text-base font-bold" style={{ color: "#111827" }}>AI StoryCraft Studio</span>
          </Link>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6" style={{ fontSize: '14px' }}>
            <Link to="/" className="link-animated" style={{ color: '#6B7280' }}>Home</Link>
            <Link to="/#pricing" className="link-animated" style={{ color: '#6B7280' }}>Pricing</Link>
            <Link to="/privacy-policy" className="link-animated" style={{ color: '#6B7280' }}>Privacy Policy</Link>
            <Link to="/terms-of-service" className="link-animated" style={{ color: '#6B7280' }}>Terms of Service</Link>
            <Link to="/app/support" className="link-animated" style={{ color: '#6B7280' }}>Contact</Link>
          </div>

          <div className="flex items-center gap-4" style={{ fontSize: '14px' }}>
            <a href="https://youtube.com/@issacai" target="_blank" rel="noopener noreferrer" className="link-animated" style={{ color: '#6B7280' }}>YouTube</a>
            <a href="https://tiktok.com/@issacai" target="_blank" rel="noopener noreferrer" className="link-animated" style={{ color: '#6B7280' }}>TikTok</a>
            <a href="https://instagram.com/issacai" target="_blank" rel="noopener noreferrer" className="link-animated" style={{ color: '#6B7280' }}>Instagram</a>
          </div>

          <div className="flex items-center gap-2 text-xs" style={{ color: '#9CA3AF' }}>
            <Lock className="w-3 h-3" />
            <span>Secure payments powered by Stripe</span>
          </div>

          <p className="text-xs" style={{ color: '#9CA3AF' }}>
            © 2026 AI Storycraft Studio. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
